var map = {
	"./g1.png": 6178,
	"./g10.png": 6322,
	"./g2.png": 1112,
	"./g3.png": 5288,
	"./g4.png": 3005,
	"./g5.png": 7652,
	"./g6.png": 4328,
	"./g7.png": 8149,
	"./g8.png": 966,
	"./g9.png": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5408;